(function () {
  const apiName = 'rewahardMobileMenuSliders';

  if (window[apiName]) {
    window[apiName].mount();
    return;
  }

  const mount = () => {
    const mobileHeader = document.querySelector('.header-mobile--culture-home');

    if (!mobileHeader) {
      return;
    }

    mobileHeader.querySelectorAll('[data-mobile-slider-mounted="true"]').forEach((slider) => slider.remove());

    const panels = Array.from(mobileHeader.querySelectorAll('.header-mobile__menu-panels[data-mobile-menu-key]'));
    const mountedMenuKeys = new Set();

    document.querySelectorAll('template.header-mobile-slider-template[data-mobile-menu-key]').forEach((template) => {
      const menuKey = template.dataset.mobileMenuKey;

      if (!menuKey || mountedMenuKeys.has(menuKey)) {
        return;
      }

      const targetPanel = panels.find((panel) => panel.dataset.mobileMenuKey === menuKey);

      if (!targetPanel) {
        return;
      }

      const fragment = template.content.cloneNode(true);
      const slider = fragment.querySelector('[data-mobile-slider-mounted="true"]');

      if (!slider) {
        return;
      }

      const menuLink = targetPanel.querySelector('.header-mobile__panel-shop-all')?.getAttribute('href');

      if (menuLink) {
        slider
          .querySelectorAll('[data-mobile-slider-use-menu-link="true"]')
          .forEach((link) => link.setAttribute('href', menuLink));
      }

      targetPanel.appendChild(fragment);
      mountedMenuKeys.add(menuKey);
    });
  };

  window[apiName] = { mount };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', () => {
    window.requestAnimationFrame(mount);
  });

  document.addEventListener('shopify:section:unload', () => {
    window.requestAnimationFrame(mount);
  });
})();
